import { Urls } from '../../Shared/Api';

export default class HomeBannerService {
    static getSliderItems() {
        return fetch(Urls.homeBanner.getData)
            .then(res => {
                return res.json();
            })
    }
}


// WEBPACK FOOTER //
// ./Src/Home/HomeBanner/HomeBannerService.js